import { party_colors } from 'components/MainComponent/party_colors'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
import { useTranslation } from 'react-i18next'

export const MunicipalityDisplay = ({
  data,
  width,
  isStatic,
  closeable,
  clearSelectedMunicipality,
}: {
  data: any
  width?: number
  isStatic?: boolean
  closeable?: boolean
  clearSelectedMunicipality?: () => void
}) => {
  const [cOaSource, setCOaSource] = useState<string | undefined>()
  const windowSize = useWindowSize()
  const ismob = windowSize.width < 711
  const { t } = useTranslation()

  useEffect(() => {
    setCOaSource(undefined)
  }, [data.bfsId])

  function loadCodeOfArms(id: number) {
    checkIfImageExists(
      'https://interaktiv.tagesanzeiger.ch/static/gemeindewappen/' +
        zeroPadBfsId(id) +
        '.png',
      (exists) => {
        if (id !== data.bfsId) loadCodeOfArms(data.bfsId)
        if (exists) {
          setCOaSource(
            'https://interaktiv.tagesanzeiger.ch/static/gemeindewappen/' +
              zeroPadBfsId(id) +
              '.png'
          )
        } else {
          setCOaSource(undefined)
        }
      }
    )
  }

  useEffect(() => {
    setCOaSource(undefined)
    if (!data || !data.bfsId) return
    loadCodeOfArms(data.bfsId)

  }, [data.bfsId])
  if (!data) {
    setCOaSource(undefined)
    return null
  }
  const { name_de, year, results } = data
  var maxData = 70

  maxData = Math.max(
    ...(Object.values(data.results).filter((f) => f !== '.') as number[])
  )
  return (
    <MunicipalityDisplayRoot
      style={{
        backgroundColor: isStatic
          ? 'var(--tooltip-background)'
          : 'var(--site-background)',
      }}
    >
      {/* <Spacer /> */}
      {closeable && (
        <CloseButton
          onClick={() =>
            clearSelectedMunicipality && clearSelectedMunicipality()
          }
        >
          X
        </CloseButton>
      )}
      <CodeOfArmsGroup>
        <CodeOfArms src={cOaSource} />
        {name_de && <Title>{name_de === 'Schweiz' ? t(`swissmap:switzerland`) : name_de}</Title>}
        <DataSub>{t("swissmap:nationalCouncilElection")}</DataSub>
        {year && <DataTitle>{year}</DataTitle>}
      </CodeOfArmsGroup>
      <DataGroup>
        <DataTable>
          <thead>
            <tr>
              <td style={{ width: '80px' }}></td>
              <td style={{ minWidth: ismob ? '150px' : '80px' }}></td>
              <td style={{ width: '50px' }}></td>
            </tr>
          </thead>
          <tbody>
            {Object.entries(results)
              .sort((a: any, b: any) => {
                if (isNaN(+a[1])) return 1
                if (isNaN(+b[1])) return -1
                return +(b[1] as number) - +(a[1] as number)
              })
              .map((m: any, i) => {
                return (
                  <tr key={'tbalerow_' + i}>
                    <NameCell>{t(`swissmap:parties:${m[0]}`)}</NameCell>
                    <BarCell>
                      <Bar
                        style={{
                          width: isNaN(+m[1])
                            ? 0
                            : (m[1] * 100) / maxData + '%',
                          backgroundColor: party_colors[m[0]],
                        }}
                      />
                    </BarCell>
                    <ValueCell>
                      {isNaN(+m[1]) ? (
                        <>&mdash;</>
                      ) : (
                        <>
                          {(+m[1]).toFixed(1)}
                          <span>%</span>
                        </>
                      )}
                    </ValueCell>
                  </tr>
                )
              })}
          </tbody>
        </DataTable>
        <Note>{t('swissmap:centerNote')}</Note>
      </DataGroup>
      {/* <Spacer /> */}
    </MunicipalityDisplayRoot>
  )
}

const Note = styled.div`
  font-size: 12px;
  line-height: 1.2em;
  margin-top: 10px;
`

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: 0;
  font-size: 22px;
`

const MunicipalityDisplayRoot = styled.div`
  /* border: 1px solid var(--gray-2); */
  display: flex;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  flex-wrap: wrap;
  padding: 30px;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  max-width: 700px;

  /* margin-top: 30px; */
`

const CodeOfArmsGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 30px;
  flex-direction: column;
  flex-wrap: wrap;
  text-align: center;
  /* border: 1px solid var(--red-main); */
  flex: 1 1 calc(min(50%, 160px));
  /* margin-right: 30px; */

  @media screen and (max-width: 711px) {
    flex: 0 0 100%;
  }
`

const DataGroup = styled.div`
  flex: 1 1 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  /* border: 1px solid var(--red-main); */
  @media screen and (max-width: 711px) {
    flex: 0 0 100%;
    margin-top: 30px;
  }
`

const DataTitle = styled.div`
  font-weight: 700;
  font-size: 22px;
`

const DataSub = styled.div`
  line-height: 1.4em;
  font-size: 15px;
`

const DataTable = styled.table`
  /* border: 1px solid var(--gray-2); */
  table-layout: fixed;
  font-size: 12px;
  line-height: 1.6em;
`
const NameCell = styled.td`
  text-align: left;
  border-bottom: 1px solid var(--table-cell-border);
`
const BarCell = styled.td`
  text-align: left;
  border-bottom: 1px solid var(--table-cell-border);
  /* border-left: 1px solid var(--text-color); */
  padding: 0;
  padding-left: 0px;
  line-height: 0;
`

const Bar = styled.div`
  height: 16px;
  background-color: var(--red-main);
  margin-top: -2px;
`
const ValueCell = styled.td`
  text-align: right;
  border-bottom: 1px solid var(--table-cell-border);
  span {
    padding-left: 2px;
    font-size: 12px;
  }
`
const Spacer = styled.div`
  flex: 1 1 auto;
`
const CodeOfArms = styled.img`
  max-width: 60px;
  margin-bottom: 15px;
`

const Title = styled.div`
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 30px;
`
const checkIfImageExists = (
  url: string,
  callback: (exists: boolean) => void
) => {
  const img = new Image()
  img.src = url

  if (img.complete) {
    callback(true)
  } else {
    img.onload = () => {
      callback(true)
    }

    img.onerror = () => {
      callback(false)
    }
  }
}
function zeroPadBfsId(bfsId: number) {
  return bfsId.toString().padStart(4, '0')
}
